<template>
  <basic-container>
    <div class="editDialog">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        :disabled="$route.query.log"
        label-width="170px"
      >
        <div class="title">资源信息</div>

        <div class="content">
          <!-- 第一行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="资源分类：" prop="module">
                <el-select
                  v-model="formData.module"
                  :disabled="$route.query.id"
                  style="width: 100%"
                  placeholder="请选择资源分类"
                >
                  <el-option label="影视类" :value="1"></el-option>
                  <el-option label="平台类" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="资源状态：" prop="status">
                <el-radio-group v-model="formData.status">
                  <el-radio :label="1">上线</el-radio>
                  <el-radio :label="0">下线</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第二行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="乐播媒资 ID：" prop="id">
                {{ $route.query.id || "--" }}
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="媒资来源：" prop="partnerId">
                <el-select
                  v-model="formData.partnerId"
                  style="width: 100%"
                  placeholder="请选择媒资来源"
                >
                  <el-option
                    v-for="item in mediaSourceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第三行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="响应方式：" prop="skipType">
                <el-select
                  v-model="formData.skipType"
                  style="width: 100%"
                  placeholder="请选择响应方式"
                >
                  <el-option
                    v-for="item in skipTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="链接（二维码）地址：" prop="qrCode">
                <el-input
                  v-model="formData.qrCode"
                  :maxlength="999"
                  placeholder="请输入链接（二维码）地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="title">媒资信息</div>

        <div class="content">
          <div style="text-align: right; color: #0f40f5; margin: -15px 0 15px">
            <span style="cursor: pointer" @click="mediaInfodialogVisible = true"
              >三方媒资信息</span
            >
          </div>

          <!-- 第一行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="媒资名称：" prop="name">
                <el-input
                  v-model="formData.name"
                  :maxlength="99"
                  placeholder="请输入媒资名称"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="媒资类型：" prop="type">
                <el-select
                  v-model="formData.type"
                  style="width: 100%"
                  placeholder="请选择媒资类型"
                >
                  <el-option
                    v-for="item in mediaTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第二行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="副标题：" prop="title">
                <el-input
                  v-model="formData.title"
                  :maxlength="999"
                  placeholder="请输入副标题"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="短描述：" prop="aword">
                <el-input
                  v-model="formData.aword"
                  :maxlength="999"
                  placeholder="请输入短描述"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第三行 -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="长描述：" prop="descr">
                <el-input
                  v-model="formData.descr"
                  placeholder="请输入长描述"
                  type="textarea"
                  :maxlength="999"
                  :rows="4"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四行 推荐标签 -->
          <el-row>
            <el-col :span="11">
              <el-form-item prop="recommendedTags">
                <template slot="label">
                  <span>推荐标签：</span>
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="服务于App展示媒资内容的推荐标签（搜索结果、榜单等）"
                  >
                    <i slot="reference" class="el-icon-warning"></i>
                  </el-popover>
                </template>
                <el-input
                  v-model="formData.recommendedTags"
                  :maxlength="99"
                  placeholder="请输入推荐标签"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第五行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="标签：" prop="category">
                <el-input
                  v-model="formData.categoryItem"
                  placeholder="请输入标签"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <el-button style="margin-left: 20px" @click="addCategoryItem">
                添加
              </el-button>
            </el-col>
            <el-col :span="11"></el-col>
          </el-row>
          <div style="margin-left: 170px">
            <el-tag
              :key="tag"
              style="margin: 0 10px 10px 0"
              v-for="tag in formData.category"
              closable
              :disable-transitions="false"
              @close="handleClose(tag, formData.category)"
            >
              {{ tag }}
            </el-tag>
          </div>

          <!-- 第六行 封面列表 -->
          <el-row>
            <el-form-item label="封面列表：" prop="vodCoverSaveOrUpdateVO">
              <el-button @click="() => $refs.editCoverRef.show({})"
                >添加</el-button
              >
            </el-form-item>
            <cover-list
              :data.sync="formData.vodCoverSaveOrUpdateVO"
              @edit="
                data => {
                  $refs.editCoverRef.show(data);
                }
              "
            ></cover-list>
          </el-row>
        </div>

        <div class="title" v-if="formData.module == 1">影视媒资信息</div>

        <div class="content" v-if="formData.module == 1">
          <!-- 第一行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="语言：" prop="language">
                <el-select
                  v-model="formData.language"
                  style="width: 100%"
                  placeholder="请选择语言"
                >
                  <el-option label="普通话" value="普通话"></el-option>
                  <el-option label="英文" value="英文"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="地域：" prop="area">
                <el-input
                  v-model="formData.area"
                  placeholder="请输入地域"
                  :maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第二行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="导演名称：" prop="director">
                <el-input
                  v-model="formData.director"
                  placeholder="请输入导演名称"
                  :maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="上映时间：" prop="releaseTime">
                <el-date-picker
                  v-model="formData.releaseTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择上映时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第三行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="媒体评分：" prop="score">
                <el-input
                  v-model="formData.score"
                  placeholder="请输入媒体评分"
                  :maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="演员名称：" prop="actor">
                <el-input
                  v-model="formData.actorItem"
                  placeholder="请输入演员名称"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <el-button style="margin-left: 20px" @click="addActorItem">
                添加
              </el-button>
            </el-col>
            <el-col :span="11"></el-col>
          </el-row>
          <div style="margin: 0px 0 25px 170px">
            <el-tag
              :key="tag"
              style="margin: 0 10px 10px 0"
              v-for="tag in formData.actor"
              closable
              :disable-transitions="false"
              @close="handleClose(tag, formData.actor)"
            >
              {{ tag }}
            </el-tag>
          </div>

          <!-- 第五行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="付费模式" prop="feeMode">
                <el-select
                  v-model="formData.feeMode"
                  style="width: 100%"
                  placeholder="请选择付费模式"
                >
                  <el-option label="免费" :value="0"></el-option>
                  <el-option label="会员免费" :value="1"></el-option>
                  <el-option label="单点付费" :value="2"></el-option>
                  <el-option label="分集解锁" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="权益天数：" prop="vodDays">
                <el-input
                  v-model="formData.vodDays"
                  placeholder="请输入权益天数"
                  :maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第一行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="总集数：" prop="totalEpisode">
                <el-input
                  v-model="formData.totalEpisode"
                  placeholder="请输入总集数"
                  :maxlength="99"
                ></el-input>
                <!-- {{ formData.totalEpisode || '--' }} -->
              </el-form-item>
            </el-col>

            <el-col :span="2"> </el-col>

            <el-col :span="11">
              <el-form-item label="剧集更新：" prop="updateEpisode">
                <el-input
                  v-model="formData.updateEpisode"
                  placeholder="请输入剧集更新"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第二行 -->
          <el-row>
            <el-col :span="11">
              <el-form-item label="是否完结：" prop="isEnd">
                <el-select
                  v-model="formData.isEnd"
                  style="width: 100%"
                  placeholder="请选择是否完结"
                >
                  <el-option label="否" :value="0"></el-option>
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="title">定价信息</div>

        <div class="content">
          <el-form-item label="价格呈现：">
            <el-button @click="handleAddPice">添加</el-button>
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              content="按渠道添加价格展示，不添加价格，则媒资不展示价格"
            >
              <i
                slot="reference"
                style="margin-left: 20px; width: 10px"
                class="el-icon-question"
              ></i>
            </el-popover>
          </el-form-item>
          <el-table :data="formData.priceList" border style="width: 100%">
            <el-table-column
              type="index"
              label="No"
              width="50"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="channelDesc"
              label="渠道"
            >
            </el-table-column>
            <el-table-column prop="useType" label="价格样式">
              <template slot-scope="{ row }">
                <span>{{ row.useType == "1" ? "原价样式" : "" }}</span>
                <span>{{ row.useType == "2" ? "现价样式" : "" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="former" label="原价"> </el-table-column>
            <el-table-column prop="now" label="现价">
              <template slot-scope="{ row }">
                <span>{{ row.now ? row.now : "-" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="suffix" label="价格后缀">
              <template slot-scope="{ row }">
                <span>{{ row.suffix ? row.suffix : "-" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="更新时间">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  size="small"
                  @click="handlePriceEdit(row.id, row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handlePriceDel(row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="title" v-if="$route.query.id">分集说明</div>

        <div class="content" v-if="$route.query.id">
          <!-- 第一行 -->

          <el-form-item label="添加分集：" style="margin-bottom: -20px">
            <el-button @click="episodeListAdd">添加</el-button>
          </el-form-item>

          <!-- 第二行 -->
          <el-row>
            <avue-crud
              :option="episodeListOption"
              :data="formData.episodeList"
              ref="crud"
              @sortable-change="sortDetailChange"
            >
              <!-- 自定义表格列 -->
              <template #name="scope">
                <span style="color: #3370ff">{{
                  scope.row.name ? scope.row.name : "-"
                }}</span>
              </template>
              <template #episodeMovie="scope">
                <span style="color: #3370ff">{{
                  scope.row.episodeMovie
                    ? {
                        0: "否",
                        2: "是"
                      }[scope.row.episodeMovie.feeMode] ||
                      "--" ||
                      "-"
                    : "-"
                }}</span>
              </template>
              <!-- 自定义表格操作栏 -->
              <template #menu="{ row }">
                <span class="_btn" @click="handleLog(row.id, 2)">日志</span>
                <span
                  class="_btn"
                  @click="handleShowImage(row.playUrl, 'video')"
                  >预览</span
                >
                <span class="_btn" @click="episodeListEdit(row)">编辑</span>
                <span class="_btn" @click="handleDetail(row)">详情</span>
                <span
                  v-if="row.status === 0"
                  class="_btn"
                  @click="detailOnline(row.id, 1)"
                  >上线</span
                >
                <span
                  v-if="row.status === 1"
                  class="_btn"
                  @click="detailOnline(row.id, 0)"
                  >下线</span
                >
                <span
                  class="_btn"
                  v-if="row.addType === 0"
                  @click="handleDel(row.id)"
                  >删除</span
                >
              </template>
            </avue-crud>
          </el-row>
        </div>

        <div class="title" v-if="$route.query.id">片花</div>

        <div class="content" v-if="$route.query.id">
          <!-- 第一行 -->

          <el-form-item label="添加片花：" style="margin-bottom: -20px">
            <el-button @click="trailerListAdd">添加</el-button>
          </el-form-item>
          <!-- 第二行 -->
          <el-row>
            <avue-crud
              :option="trailerListOption"
              :data="formData.trailerList"
              ref="crud"
              @sortable-change="trailerListSortDetailChange"
            >
              <!-- 自定义表格列 -->
              <template #name="scope">
                <span style="color: #3370ff">{{
                  scope.row.name ? scope.row.name : "-"
                }}</span>
              </template>
              <!-- 自定义表格操作栏 -->
              <template #menu="{ row }">
                <span @click="handleLog(row.id, 3)" class="_btn">日志</span>
                <span
                  @click="handleShowImage(row.playUrl, 'video')"
                  class="_btn"
                  >预览</span
                >
                <span class="_btn" @click="trailerListEdit(row)">编辑</span>
                <span class="_btn" @click="trailerListDetail(row)">详情</span>
                <span
                  class="_btn"
                  v-if="row.status === 0"
                  @click="trailerListdetailOnline(row.id, 1)"
                  >上线</span
                >
                <span
                  class="_btn"
                  v-if="row.status === 1"
                  @click="trailerListdetailOnline(row.id, 0)"
                  >下线</span
                >
                <span
                  class="_btn"
                  v-if="row.addType === 0"
                  @click="trailerListhandleDel(row.id)"
                  >删除</span
                >
              </template>
            </avue-crud>
          </el-row>
        </div>

        <div style="text-align: right; margin: 40px 0 100px">
          <el-button type="primary" @click="mediaSave">保存</el-button>
          <el-button @click="handleReturnPage">取消</el-button>
        </div>
      </el-form>
    </div>

    <!-- 三方媒资信息 -->
    <mediaInfo
      v-model="mediaInfodialogVisible"
      v-if="mediaInfodialogVisible"
      :row="formData"
    ></mediaInfo>
    <!-- 分集 -->
    <diversityInfo
      v-model="diversityInfodialogVisible"
      v-if="diversityInfodialogVisible"
      :sort="formData.episodeList.length"
      :isDisabled="episodeListDisabled"
      @input="upDataPart"
      :row="episodeListEditItem"
      :partnerId="formData.partnerId"
    ></diversityInfo>
    <!-- 片花 -->
    <trailerInfo
      v-model="trailerInfodialogVisible"
      v-if="trailerInfodialogVisible"
      :sort="formData.trailerList.length"
      :isDisabled="trailerListDisabled"
      @input="upDataPart"
      :row="trailerListEditItem"
      :partnerId="formData.partnerId"
    ></trailerInfo>
    <!-- 日志 -->
    <LogDialog ref="logDialog"></LogDialog>
    <!-- 定价价格 -->
    <PriceDialog
      ref="priceDialog"
      @updateList="
        () => {
          initData();
        }
      "
    ></PriceDialog>
    <edit-cover ref="editCoverRef" @updateCover="updateCover"></edit-cover>
  </basic-container>
</template>

<script>
import mediaInfo from "./editDialog_componts/mediaInfo.vue";
import diversityInfo from "./editDialog_componts/diversityInfo.vue";
import trailerInfo from "./editDialog_componts/trailerInfo.vue";
import { getMediaSource } from "@/api/mediaManage/mediaOrder.js";
import episodeListOption from "./editDialog_componts/episodeListOption";
import trailerListOption from "./editDialog_componts/trailerListOption";
import LogDialog from "./editDialog_componts/log.vue";
import PriceDialog from "./editDialog_componts/priceAdd.vue";
import CoverList from "./editDialog_componts/coverComponents/coverList.vue";
import EditCover from "./editDialog_componts/coverComponents/addCoverPopup.vue";
import {
  getDetail,
  mediaSaveApi,
  mediaUpdateApi,
  mediaEpisodeResetSortApi,
  mediaEpisodePutOnApi,
  mediaEpisodeTakeOffApi,
  mediaEpisodeDeleteApi,
  trailerPutOnApi,
  trailerTakeOffApi,
  trailerResetSortApi,
  trailerDeleteApi,
  deletePriceApi
} from "@/api/mediaManage/mediaContentManage.js";
import { mediaTypeList, skipTypeList } from "./option";

export default {
  components: {
    mediaInfo,
    trailerInfo,
    diversityInfo,
    LogDialog,
    PriceDialog,
    CoverList,
    EditCover
  },
  data() {
    return {
      episodeListOption: episodeListOption(this),
      trailerListOption: trailerListOption(this),
      mediaInfodialogVisible: false, //三方媒资信息
      diversityInfodialogVisible: false, //分集编辑-短剧
      trailerInfodialogVisible: false, //片花编辑-短剧

      episodeListEditItem: {}, //分集编辑回显示内容
      episodeListDisabled: false, //分集详情 || 不让编辑

      trailerListEditItem: {}, //片花编辑回显示内容
      trailerListDisabled: false, //片花详情 || 不让编辑

      imageUrl: "", //上传url
      formData: {
        category: [],
        actor: [],
        episodeList: [], //  分集列表
        trailerList: [], //  片花列表
        vodCoverSaveOrUpdateVO: [], // 封面列表
        status: 1,
        useType: 1
      }, //表单数据
      mediaSourceList: [], // 媒资来源选择框
      // 响应方式
      skipTypeArr: skipTypeList,
      // 媒资类型
      mediaTypeArr: mediaTypeList,
      rules: {
        module: [
          { required: true, message: "请选择资源分类", trigger: "change" }
        ],
        vodDays: [
          { required: true, message: "请选择资源分类", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择资源状态", trigger: "change" }
        ],
        partnerId: [
          { required: true, message: "请选择资源来源", trigger: "change" }
        ],
        skipType: [
          { required: true, message: "请选择响应方式", trigger: "change" }
        ],
        name: [{ required: true, message: "请输入媒资名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择媒资类型", trigger: "change" }
        ],
        feeMode: [
          { required: true, message: "请选择付费模式", trigger: "change" }
        ],
        useType: [
          { required: true, message: "请选择价格展示", trigger: "change" }
        ],
        former: [{ required: true, message: "请输入原价", trigger: "blur" }],
        isEnd: [
          { required: true, message: "请选择是否完结", trigger: "change" }
        ],
        vodCoverSaveOrUpdateVO: [
          { required: true, validator: this.validateUpload, trigger: "change" }
        ]
      }
    };
  },

  created() {
    this.$nextTick(() => {
      // this.$refs.formData.resetFields();
    });
    this.initData();
    this.getMediaSource();
  },

  methods: {
    // 取消/返回
    handleReturnPage() {
      this.$router.$avueRouter.closeTag(this.$route.fullPath);
      this.$router.push("/mediaManage/mediaContentManage/index");
    },
    // 删除定价
    handlePriceDel(id) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const { data } = await deletePriceApi(id);
        if (data.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.initData();
        }
      });
    },
    // 编辑定价
    handlePriceEdit(id, params) {
      console.log("编辑定价", id);
      this.$refs.priceDialog.show(id, params);
    },
    // 添加定价
    handleAddPice() {
      this.$refs.priceDialog.show();
    },
    // 局部更新 分集 & 片花
    async upDataPart() {
      if (!this.$route.query.id) return;
      const { data } = await getDetail(this.$route.query.id);
      (this.formData.episodeList = data.data.episodeList || []), //分集列表
        (this.formData.trailerList = data.data.trailerList || []); //片花列表
    },

    // 上线分集 || 下线分集
    detailOnline(id, type) {
      let api = type ? mediaEpisodePutOnApi : mediaEpisodeTakeOffApi;

      api({ id: id }).then(res => {
        console.log("上线分集 || 下线分集:", type, "res---", res);
        this.upDataPart();
      });
    },

    // 上线片花 || 下线片花
    trailerListdetailOnline(id, type) {
      let api = type ? trailerPutOnApi : trailerTakeOffApi;

      api({ id: id }).then(res => {
        console.log("上线片花 || 下线片花:", type, "res---", res);
        this.upDataPart();
      });
    },

    // 删除分集
    handleDel(id) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          mediaEpisodeDeleteApi({ id: id }).then(res => {
            console.log("删除分集", res);
            this.upDataPart();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 删除片花
    trailerListhandleDel(id) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          trailerDeleteApi({ id: id }).then(res => {
            console.log("删除分集", res);
            this.upDataPart();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 分集日志
    handleLog(id, type) {
      this.$refs.logDialog.show(id, type);
    },
    // 预览img，video
    handleShowImage(url, type) {
      console.log("handleShowImage", url, type);
      // let _dom = type === 'video' ? type + ' controls' : 'img'
      // this.$alert(`<${_dom} src='` + url + "' style='width:100%'>", '图片/视频展示', {
      //   dangerouslyUseHTMLString: true,
      //   showConfirmButton: false,
      //   customClass: 'showImage',
      // });
      let _dom = "video controls";
      this.$alert(
        `<${_dom} src='` + `${url}` + "' style='width:100%'>",
        "图片/视频展示",
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true,
          customClass: "showImage",
          callback: () => {
            // 在弹窗关闭时执行停止视频播放的操作
            const videoElement = document.querySelector(".showImage video");
            if (videoElement) {
              videoElement.pause();
            }
            // 监听视频加载错误事件
            videoElement.addEventListener("error", () => {
              this.$toast("无法预览");
            });
          }
        }
      );
    },
    //分集添加
    episodeListAdd() {
      this.episodeListEditItem = {};
      this.diversityInfodialogVisible = true;
      this.episodeListDisabled = false;
    },

    //片花添加
    trailerListAdd() {
      this.trailerListEditItem = {};
      this.trailerInfodialogVisible = true;
      this.trailerListDisabled = false;
    },

    //分集详情
    handleDetail(item) {
      this.episodeListDisabled = true;
      this.episodeListEditItem = item;
      this.diversityInfodialogVisible = true;
    },

    //片花详情
    trailerListDetail(item) {
      this.trailerListDisabled = true;
      this.trailerListEditItem = item;
      this.trailerInfodialogVisible = true;
    },

    // 分集编辑
    episodeListEdit(item) {
      this.episodeListEditItem = item;
      this.diversityInfodialogVisible = true;
      this.episodeListDisabled = false;
      console.log(item);
    },

    // 片花编辑
    trailerListEdit(item) {
      this.trailerListEditItem = item;
      this.trailerInfodialogVisible = true;
      this.trailerListDisabled = false;
      console.log(item);
    },

    // 分集排序
    async sortDetailChange(oldindex, newindex, row, list) {
      console.log("row", row);
      console.log("list", list);
      /** 只留下分集id */
      const episodeIdList = list.map(item => {
        return item.id;
      });

      console.log("排序之后的idList", episodeIdList);
      const { data } = await mediaEpisodeResetSortApi({
        mediaId: this.$route.query.id,
        episodeIdList
      });
      console.log("分集排序之后的响应", data);
      /** 如果成功 */
      if (data.code === 200) {
        /** 更新数据 */
        // this.getDetail();
        this.$message.success("排序成功");
      }
    },
    // 片花排序
    async trailerListSortDetailChange(oldindex, newindex, row, list) {
      console.log("row", row);
      console.log("list", list);
      /** 只留下片花id */
      const trailerIdList = list.map(item => {
        return item.id;
      });

      console.log("排序之后的idList", trailerIdList);
      const { data } = await trailerResetSortApi({
        mediaId: this.$route.query.id,
        trailerIdList
      });
      console.log("片花排序之后的响应", data);
      /** 如果成功 */
      if (data.code === 200) {
        /** 更新数据 */
        // this.getDetail();
        this.$message.success("排序成功");
      }
    },

    // 校验上传封面图片
    validateUpload(rule, value, callback) {
      console.log("rule:", rule, "value:", value);

      if (this.formData.vodCoverSaveOrUpdateVO.length > 0) {
        callback(); // 校验通过
      } else {
        callback(new Error("请上传文件")); // 校验不通过
      }
    },

    //媒资来源下拉列表的数据
    async getMediaSource() {
      const { data } = await getMediaSource({ status: 1 });
      console.log("媒资来源下拉列表的数据", data);
      this.mediaSourceList = data.data;
    },

    // 添加演员
    addActorItem() {
      if (this.formData.actorItem && this.formData.actorItem.trim()) {
        this.formData.actor.push(this.formData.actorItem);
        this.formData.actorItem = "";
      } else {
        this.$message({
          message: "请勿添加空标签！",
          type: "warning"
        });
      }
    },

    // 添加标签
    addCategoryItem() {
      if (this.formData.categoryItem && this.formData.categoryItem.trim()) {
        this.formData.category.push(this.formData.categoryItem);
        this.formData.categoryItem = "";
      } else {
        this.$message({
          message: "请勿添加空标签！",
          type: "warning"
        });
      }
    },

    // 获取详情
    async initData() {
      if (!this.$route.query.id) return;
      const { data } = await getDetail(this.$route.query.id);
      this.formData = {
        ...data.data,
        ...data.data.movie,
        ...data.data.price,
        category: data.data.category ? data.data.category.split(",") : [],
        actor: data.data.movie.actor ? data.data.movie.actor.split(",") : [],
        episodeList: data.data.episodeList || [], //分集列表
        trailerList: data.data.trailerList || [], //片花列表
        vodCoverSaveOrUpdateVO: data.data.vodCoverSaveOrUpdateVO || []
      };
      console.log("获取详情------------>", data);
    },
    // 保存媒资
    mediaSave() {
      // 需要转换为后端需要的数据结构

      let params = {
        ...this.formData,
        id: this.$route.query.id || "",
        category:
          Array.isArray(this.formData.category) && this.formData.category.length
            ? this.formData.category.join(",")
            : "",
        movie: {
          actor:
            Array.isArray(this.formData.actor) && this.formData.actor.length
              ? this.formData.actor.join(",")
              : "",
          area: this.formData.area,
          director: this.formData.director,
          feeMode: this.formData.feeMode,
          isEnd: this.formData.isEnd,
          language: this.formData.language,
          releaseTime: this.formData.releaseTime,
          score: this.formData.score,
          totalEpisode: this.formData.totalEpisode || 0,
          updateEpisode: this.formData.updateEpisode,
          vodDays: this.formData.vodDays
        },
        price: {
          former: this.formData.former,
          now: this.formData.now,
          suffix: this.formData.suffix,
          useType: this.formData.useType
        }
      };
      let api = this.$route.query.id ? mediaUpdateApi : mediaSaveApi;

      this.$refs.formData.validate(valid => {
        if (valid) {
          api(params).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: "保存成功!",
                type: "success"
              });
              this.handleReturnPage()
            }
            console.log(res);
          });
        } else {
          this.$message.error("请完善表单信息");
          return false;
        }
      });
    },

    // 删除标签
    handleClose(tag, list) {
      list.splice(list.indexOf(tag), 1);
    },

    // 更新封面列表
    updateCover(data) {
      // 初始化vodCoverSaveOrUpdateVO数组
      if (!this.formData.vodCoverSaveOrUpdateVO) {
        this.formData.vodCoverSaveOrUpdateVO = [];
      }

      // 判断是新增还是修改
      if (typeof data.$index === "undefined" || data.$index === null) {
        // 新增操作
        this.addNewCover(data);
      } else {
        // 修改操作
        this.updateExistingCover(data);
      }
    },

    // 新增封面
    addNewCover(data) {
      const newCoverItem = {
        id: data.id || null,
        coverImageUrl: data.coverImageUrl || "",
        coverImageType: data.coverImageType || 1,
        coverImageOrder: this.formData.vodCoverSaveOrUpdateVO.length + 1,
        top: this.formData.vodCoverSaveOrUpdateVO.length === 0,
        updateTime: data.updateTime || ""
      };

      this.formData.vodCoverSaveOrUpdateVO.push(newCoverItem);
      console.log("新增封面成功:", newCoverItem);
    },

    // 更新现有封面
    updateExistingCover(data) {
      const index = data.$index;

      if (index >= 0 && index < this.formData.vodCoverSaveOrUpdateVO.length) {
        this.formData.vodCoverSaveOrUpdateVO[index] = {
          ...this.formData.vodCoverSaveOrUpdateVO[index],
          ...data
        };
        this.formData.vodCoverSaveOrUpdateVO = [
          ...this.formData.vodCoverSaveOrUpdateVO
        ];
        console.log(
          "修改封面成功:",
          this.formData.vodCoverSaveOrUpdateVO[index]
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
  padding: 25px 0;
  color: #000;
}

.content {
  background-color: #f6f6f6;
  padding: 45px 45px 20px;
  border-radius: 10px;
}
.editDialog {
  padding: 50px 100px !important;
}

._btn {
  cursor: pointer;
  color: #629bfe;
  padding-left: 15px;
}
</style>
